// src/components/legal/TermsGatekeeper.tsx
// ─────────────────────────────────────────────────────────────
// BLOQUEO OBLIGATORIO (GATEKEEPER) DE NIIZ
//
// Si la instalación local (db.settings) existe y NO tiene aceptados los
// términos de la versión vigente, se monta un modal NO DESCARTABLE que bloquea
// por completo la plataforma. Al aceptar se guarda la fecha exacta y la versión
// del contrato aceptado (`terms_accepted`, `terms_accepted_at`, `terms_version`).
//
// Si no hay fila de configuración (visitas públicas: landing, registro,
// tienda digital de un cliente) no hay nada que bloquear.
// ─────────────────────────────────────────────────────────────

import { useLiveQuery } from 'dexie-react-hooks';
import { toast } from 'sonner';
import { db } from '@/db/db';
import { useConfigStore } from '@/store/configStore';
import { TERMS_VERSION } from '@/lib/termsContent';
import { TermsModal } from '@/components/legal/TermsModal';

export const TermsGatekeeper = () => {
  const settings = useLiveQuery(() => db.settings.toCollection().first(), []);

  // Sin instalación local (aún no registrado / visitante público) no se bloquea.
  if (!settings?.id) return null;

  const isAccepted =
    settings.terms_accepted === true && String(settings.terms_version || '') === TERMS_VERSION;

  if (isAccepted) return null;

  const handleAccept = async () => {
    try {
      await db.settings.update(settings.id!, {
        terms_accepted: true,
        terms_accepted_at: new Date().toISOString(),
        terms_version: TERMS_VERSION,
      } as any);
      // Refrescar el store para que el resto de la app vea el consentimiento.
      try {
        await useConfigStore.getState().loadSettings();
      } catch {
        /* el store se refresca solo al navegar */
      }
      toast.success('Términos y condiciones aceptados · Bienvenido a NiiZ', {
        description: `Contrato versión ${TERMS_VERSION} aceptado en este dispositivo.`,
      });
    } catch (e: any) {
      toast.error(`No se pudo guardar la aceptación: ${e?.message || 'error local'}`);
      throw e;
    }
  };

  return (
    <TermsModal
      isOpen
      blocking
      acceptedAt={settings.terms_accepted_at || null}
      onAccept={handleAccept}
    />
  );
};

export default TermsGatekeeper;
